export enum EntityAction {
  Edit,
  Remove,
  ReVerify
}
